<template>
  <div class="home-page">
    <div class="page-wrap">
      <!-- 主体 -->
      <!-- 数据看板 -->
      <DataBoard></DataBoard>
      <!-- 公司概况 -->
      <Company></Company>
      <!-- 业务板块 -->
      <Business></Business>
      <!-- 新闻信息 -->
      <News></News>

      <!-- 服务客户 -->
      <Service></Service>
    </div>
  </div>
</template>

<script>
import DataBoard from './components/DataBoard.vue'
import Company from './components/Company.vue'
import Business from './components/Business.vue'
import News from './components/News.vue'
import Service from './components/Service.vue'

export default {
  components: {
    DataBoard,
    Company,
    Business,
    News,
    Service
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  display: flex;
  flex-direction: column;
}
</style>
